// extracted by css-extract-rspack-plugin
export default {"Box":"filter-input-actions-module__Box__oDpBc","Box_1":"filter-input-actions-module__Box_1__yUIMG"};